import { useState, useEffect, useCallback } from 'react';

const EBF = window.EulerBeatsFutura;

const INITIAL_STATE = {
  'Lightning' : false,
  'Light Pulse' : false,
  'Orbiting Particles' : false,
  'Light Waves' : false,
  'Shaking' : false,
  'Spheres' : false,
  'Laser' : false,
  'Light Flickering' : false,
}

const getNoteEffect = (note) => {
  const noteTraits = note.context.variant?.traits;
  const trait = noteTraits?.find((trait) => trait.name === 'Effect')
  return trait?.value;
}

export const useEffectsState = () => {
  const [activeEffects, setActiveEffects] = useState<any>(INITIAL_STATE);

  const onPlayNote = useCallback((e) => {
    const effect = getNoteEffect(e.note);
    if (effect) {
      setActiveEffects((prevState) => ({
        ...prevState,
        [effect]: true
      }));
    }
  }, []);

  const onStopNote = useCallback((e) => {
    const effect = getNoteEffect(e.note);
    if (effect) {
      setActiveEffects((prevState) => ({
        ...prevState,
        [effect]: false,
      }));
    }
  }, []);

  const onEndPiece = useCallback((e) => {
    setActiveEffects(INITIAL_STATE);
  }, []);

  useEffect(() => {
    EBF.audio.addListener('playNote', onPlayNote);

    EBF.audio.addListener('stopNote', onStopNote);

    EBF.audio.addListener('endPiece', onEndPiece);

    return () => {
      EBF.audio.removeListener('playNote', onPlayNote);
      EBF.audio.removeListener('stopNote', onStopNote);
      EBF.audio.removeListener('endPiece', onEndPiece);
    }
  }, [onPlayNote, onStopNote, onEndPiece]);

  return {
    activeEffects,
  }
};
